import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Map } from 'immutable';
import { selectActiveGame } from '../ActiveGame/selectors';
import { flipStartCoin } from './actions';
import { selectFlippingCoin } from './selectors';
import { Button, Muted } from '../Controls';

const SelectHeads = ({ flipStartCoinAction, game, flippingCoin }) => {
  if (game.get('start_chooser_id')) {
    return null;
  }
  return (
    <Fragment>
      <Muted>Call the coin flip:</Muted>
      <Button onClick={() => flipStartCoinAction(true)} disabled={flippingCoin}>Heads</Button>
      <Button onClick={() => flipStartCoinAction(false)} disabled={flippingCoin}>Tails</Button>
    </Fragment>
  )
};

SelectHeads.propTypes = {
  game: PropTypes.instanceOf(Map),
  flipStartCoinAction: PropTypes.func.isRequired,
};

export default connect(
  createStructuredSelector({
    game: selectActiveGame,
    flippingCoin: selectFlippingCoin,
  }),
  {
    flipStartCoinAction: flipStartCoin,
  }
)(SelectHeads);
